import { render, staticRenderFns } from "./Updateuserid.vue?vue&type=template&id=58749556&scoped=true&"
import script from "./Updateuserid.vue?vue&type=script&lang=js&"
export * from "./Updateuserid.vue?vue&type=script&lang=js&"
import style0 from "./Updateuserid.vue?vue&type=style&index=0&id=58749556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58749556",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VRow,VTextField})
